import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Segment,
  Dimmer,
  Loader,
  Image,
  Button,
  Dropdown,
  Modal,
} from 'semantic-ui-react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { TimePicker } from 'material-ui-time-picker';
import { uiActions, workLogActions } from '../../actions/index';
import Strings from '../../common/Strings';
import '../Common.css';
import '../projects/ProjectDetails.css';
import './ActivityAddTime.css';
import {
  getHoursFromMillis,
  getLoggedTime,
  getLoggedTimeFromMillis,
} from '../../helpers/workLog';
import Constant from '../../common/Constant';

const moment = require('moment');

class ActivityAddTime extends React.Component {
  constructor(props) {
    super(props);

    const w = this.getWorkLog(props);

    this.state = {
      dragFactor: 0.0,
      notes: w && w.notes ? w.notes : '',
      startTimestamp:
        w && w.startTimestamp ? moment(w.startTimestamp) : moment(),
      endTimestamp: w && w.endTimestamp ? moment(w.endTimestamp) : moment(),
      startingAtOpen: false,
      endingAtOpen: false,
    };
  }

  componentWillReceiveProps(newProps) {
    const w1 = this.getWorkLog(this.props);
    const w2 = this.getWorkLog(newProps);

    if (w1 && w2 && w1.id !== w2.id) {
      this.setState({
        dragFactor: 0.0,
        notes: w2.notes ? w2.notes : '',
        startTimestamp: w2.startTimestamp
          ? moment(w2.startTimestamp)
          : moment(),
        endTimestamp: w2.endTimestamp ? moment(w2.endTimestamp) : moment(),
      });
    } else if (w1 && !w2) {
      this.setState({
        dragFactor: 0.0,
        startTimestamp: moment(),
        endTimestamp: moment(),
      });
    }
  }

  onNotesChange = e => {
    this.setState({ notes: e.target.value });
  };

  onPressUpdate = () => {
    const { notes, startTimestamp, endTimestamp } = this.state;
    let workLog = this.getWorkLog();
    if (!workLog) {
      workLog = { totalLoggedMillis: 0 };

      if (this.props.historyDetailsDate) {
        workLog.date = this.props.historyDetailsDate;
      }
    }

    workLog.notes = notes;
    workLog.startTimestamp = startTimestamp.format(Constant.DATE_FORMAT_LONG);
    workLog.endTimestamp = endTimestamp.format(Constant.DATE_FORMAT_LONG);

    const { dispatch, project } = this.props;
    let millis;
    if (workLog && this.state.dragFactor === this.getSliderMin()) {
      millis = -1 * workLog.totalLoggedMillis;
    } else {
      millis = this.getDragFactorAsMillis();
    }
    dispatch(workLogActions.updateWorkLog(project, workLog, millis));
  };

  onSliderChanged = value => {
    const millis = this.getMillisDelta(value);
    const startTimestamp = moment(this.state.endTimestamp).subtract(
      millis,
      'milliseconds',
    );

    this.setState({
      dragFactor: value,
      startTimestamp,
    });
  };

  getMillisDelta(dragFactor = this.state.dragFactor) {
    const millisRecorded = this.props.workLog
      ? this.props.workLog.totalLoggedMillis
      : 0;
    return millisRecorded + this.getDragFactorAsMillis(dragFactor);
  }

  getButtonStyle() {
    const w = this.getWorkLog();
    if (w) {
      if (this.state.dragFactor === this.getSliderMin()) {
        return 'common-red-button';
      }
    }
    return 'common-green-button';
  }

  getButtonText() {
    const w = this.getWorkLog();
    if (w) {
      if (this.state.dragFactor === this.getSliderMin()) {
        return Strings.ADD_TIME.deleteLog;
      }
      return Strings.ADD_TIME.submitChanges;
    }
    return Strings.ADD_TIME.submitLog;
  }

  getStartingAtText() {
    return moment(this.state.startTimestamp).format('h.mm A');
  }

  getEndingAtText() {
    return moment(this.state.endTimestamp).format('h.mm A');
  }

  getAddition() {
    const { dragFactor } = this.state;
    const workLog = this.getWorkLog();

    if (dragFactor >= 0) {
      return `+${getLoggedTimeFromMillis(this.getDragFactorAsMillis())}`;
    } else if (workLog && this.state.dragFactor === this.getSliderMin()) {
      return `-${getLoggedTime(workLog)}`;
    }
    return `-${getLoggedTimeFromMillis(-1 * this.getDragFactorAsMillis())}`;
  }

  getHoursLoggedToday() {
    const workLog = this.getWorkLog();
    if (workLog) {
      return Strings.ADD_TIME.timeLogged + getLoggedTime(workLog);
    }
    return ' ';
  }

  getSliderMin() {
    const workLog = this.getWorkLog();
    if (workLog) {
      const { alertIncrementMinutes } = this.props;
      const hours = getHoursFromMillis(workLog.totalLoggedMillis);
      let min;
      if (hours % 0.5) {
        min = Math.floor(hours) + 1;
      } else {
        min = Math.ceil(hours);
      }

      if (alertIncrementMinutes === 30) {
        min *= 2;
      } else if (alertIncrementMinutes === 15) {
        min *= 4;
      } else if (alertIncrementMinutes === 5) {
        min *= 8;
      }

      // Adjust tick count for minute increments
      if (alertIncrementMinutes !== 60) {
        min = Math.ceil((hours * 60) / alertIncrementMinutes);
      }

      // 8 ticks + delete tick max
      return Math.min(9, min) * -1;
    }
    return 0;
  }

  getWorkLog(props = this.props) {
    if (props.workLog) {
      return props.workLog.asMutable();
    }
    return undefined;
  }

  getDragFactorAsMillis(dragFactor = this.state.dragFactor) {
    const { alertIncrementMinutes } = this.props;
    return dragFactor * alertIncrementMinutes * 60 * 1000;
  }

  getStartingAtForModal() {
    return moment(this.state.startTimestamp).toDate();
  }

  getEndingAtForModal() {
    return moment(this.state.endTimestamp).toDate();
  }

  isDataChanged() {
    const w = this.getWorkLog();
    if (w) {
      const { notes, startTimestamp, endTimestamp } = this.state;
      const timestampChanged =
        moment(startTimestamp).format(Constant.DATE_FORMAT_LONG) !==
          moment(w.startTimestamp).format(Constant.DATE_FORMAT_LONG) ||
        moment(endTimestamp).format(Constant.DATE_FORMAT_LONG) !==
          moment(w.endTimestamp).format(Constant.DATE_FORMAT_LONG);
      return (
        w.notes !== notes || this.state.dragFactor !== 0.0 || timestampChanged
      );
    }

    return this.state.dragFactor > 0.0;
  }

  close = () => {
    this.props.dispatch(uiActions.activityAddTimeClicked());
  };

  changeStartingAt = time => {
    const startTimestamp = moment(time);
    const endTimestamp = startTimestamp
      .clone()
      .add(this.getMillisDelta(this.state.dragFactor), 'milliseconds');
    this.setState({ startTimestamp, endTimestamp });
  };

  changeEndingAt = time => {
    const endTimestamp = moment(time);
    const startTimestamp = endTimestamp
      .clone()
      .subtract(this.getMillisDelta(this.state.dragFactor), 'milliseconds');
    this.setState({ startTimestamp, endTimestamp });
  };

  renderTimePickerModal() {
    return (
      <div>
        <Modal
          centered
          open={this.state.startingAtOpen}
          basic
          size="mini"
          onClose={() => this.setState({ startingAtOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeStartingAt}
                value={this.getStartingAtForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ startingAtOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
        <Modal
          centered
          open={this.state.endingAtOpen}
          basic
          size="mini"
          onClose={() => this.setState({ endingAtOpen: false })}
        >
          <Modal.Content>
            <div>
              <TimePicker
                mode="12h"
                onChange={this.changeEndingAt}
                value={this.getEndingAtForModal()}
              />
              <button
                className="time-picker-modal-done"
                onClick={() => this.setState({ endingAtOpen: false })}
              >
                {Strings.COMMON.done.toUpperCase()}
              </button>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }

  render() {
    const { notes } = this.state;
    const { name, color } = this.props.project;
    const { loading, alertIncrementMinutes } = this.props;
    const max = alertIncrementMinutes === 60 ? 8 : 16;
    return (
      <div className="project-details-root">
        {this.renderTimePickerModal()}
        <div className="project-details-content-container">
          <Segment basic className="project-details-content">
            <Dimmer active={loading} inverted>
              <Loader inverted />
            </Dimmer>
            <div className="project-details-title-container">
              <h1 id="add-time-title-text" className="project-details-title">
                {this.getWorkLog()
                  ? Strings.ADD_TIME.editLog
                  : Strings.ADD_TIME.addNewLog}
              </h1>
            </div>
            <div className="project-details-divider" />
            <div id="add-time-project-name-container">
              <div
                id="add-time-project-color"
                style={{ backgroundColor: color }}
              />
              <h1 id="add-time-project-name">{name}</h1>
            </div>
            <p id="add-time-hours-logged-today">{this.getHoursLoggedToday()}</p>
            <div id="add-time-slider-container">
              <Slider
                id="add-time-slider"
                trackStyle={{ backgroundColor: color }}
                handleStyle={{ backgroundColor: 'white', borderColor: color }}
                min={this.getSliderMin()}
                max={max}
                step={1}
                defaultValue={0}
                value={this.state.dragFactor}
                onChange={value => this.onSliderChanged(value)}
              />
            </div>
            <p id="add-time-hours-added">{this.getAddition()}</p>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div className="add-time-divider" />
              <div className="add-time-time-container">
                <p className="add-time-time-text">
                  {Strings.ADD_TIME.startingAt}
                </p>
                {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
                <Dropdown
                  text={this.getStartingAtText()}
                  basic
                  className="add-time-drop-down"
                  onClick={() => this.setState({ startingAtOpen: true })}
                >
                  <Dropdown.Menu className="add-time-drop-down-hidden" />
                </Dropdown>
              </div>
              <div style={{ height: 10 }} />
              <div className="add-time-time-container">
                <p className="add-time-time-text">
                  {Strings.ADD_TIME.endingAt}
                </p>
                {/* We use Dropdown here to achieve same visual than for actual Dropdowns */}
                <Dropdown
                  text={this.getEndingAtText()}
                  basic
                  className="add-time-drop-down"
                  onClick={() => this.setState({ endingAtOpen: true })}
                >
                  <Dropdown.Menu className="add-time-drop-down-hidden" />
                </Dropdown>
              </div>
              <textarea
                id="log-notes-input"
                onChange={this.onNotesChange}
                placeholder={Strings.ADD_TIME.notesPlaceholder}
                value={notes}
              />
              <div className="add-time-divider" />
              <Button
                id="add-time-update-button"
                className={this.getButtonStyle()}
                onClick={this.onPressUpdate}
                disabled={!this.isDataChanged()}
              >
                {this.getButtonText()}
              </Button>
            </div>
          </Segment>
        </div>
        <Image
          id="add-time-close-button"
          src="/icon/close.svg"
          onClick={this.close}
        />
      </div>
    );
  }
}

ActivityAddTime.propTypes = {
  dispatch: PropTypes.func.isRequired,
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
    ownerUid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    archivedAt: PropTypes.string,
    hourlyRate: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
  }).isRequired,
  workLog: PropTypes.shape({
    totalLoggedMillis: PropTypes.number.isRequired,
    asMutable: PropTypes.func.isRequired,
  }).isRequired,
  loading: PropTypes.bool,
  historyDetailsDate: PropTypes.string.isRequired,
  alertIncrementMinutes: PropTypes.number,
};

ActivityAddTime.defaultProps = {
  loading: false,
  alertIncrementMinutes: Constant.DEFAULT_ALERT_INCREMENT_MINUTES,
};

const mapStateToProps = state => ({
  project: state.uiState.addTimeProject,
  workLog: state.uiState.addTimeWorkLog,
  loading: state.uiState.isWorkLogUpdating,
  historyDetailsDate: state.uiState.historyDetailsDate,
  alertIncrementMinutes: state.user.settings.alertIncrementMinutes,
});

export default connect(mapStateToProps)(ActivityAddTime);



// WEBPACK FOOTER //
// ./src/components/activity/ActivityAddTime.js